import { useEffect, useState } from 'react';

import { getIsOpenedInWebView } from 'src/helpers/common';

const useIsWebview = () => {
  const [isWebview, setIsWebview] = useState(false);

  useEffect(() => {
    setIsWebview(getIsOpenedInWebView(window.location));
  }, []);

  return isWebview;
};

export default useIsWebview;
